import { Box, Button, Container } from "@mui/material";
import React, { FC, ReactEventHandler } from "react";

import { Link } from "gatsby";
import logo from "@/svg/logo.svg";
import { styled } from "@mui/material/styles";

const LinkStyled = styled(Link)(() => ({
  ":hover": { background: "none" },
  textDecoration: "none",
  display: "inline-flex",
  ml: -1
}));

const NavLinkStyled = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  lineHeight: 1.5,
  fontWeight: 600,
  color: theme.palette.text.disabled,
  transition: theme.transitions.create("color", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shortest
  }),
  [theme.breakpoints.up("sm")]: {
    ":hover": {
      color: theme.palette.text.primary
    },
    ":active": {
      color: theme.palette.primary.main
    }
  }
}));

export const Header: FC<HeaderProps> = ({ navItems, headerTo, cta }) => {
  const handleClick: ReactEventHandler<HTMLAnchorElement> = event => {
    if (cta) {
      event.preventDefault();
      Calendly.initPopupWidget({ url: cta.href });
    }
  };

  return (
    <Box component="header">
      <Container maxWidth="lg" sx={{ padding: theme => theme.spacing(2) }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <LinkStyled to={headerTo}>
            <Box
              component="img"
              src={logo}
              sx={{
                height: { xs: 28, md: 40 }
              }}
            />
          </LinkStyled>
          {!!navItems && (
            <Box
              sx={{
                gap: theme => theme.spacing(4),
                display: { xs: "none", sm: "flex" }
              }}
            >
              {navItems?.map((item, index) => (
                <NavLinkStyled key={index} to={item.to}>
                  {item.label}
                </NavLinkStyled>
              ))}
            </Box>
          )}
          <Box>
            {!!cta && (
              <Button
                LinkComponent="a"
                href={cta.href}
                variant="contained"
                onClick={handleClick}
              >
                {cta.label}
              </Button>
            )}
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          display: { xs: "block", sm: "none" }
        }}
      >
        <Container maxWidth="lg" sx={{ padding: theme => theme.spacing(1, 2) }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: theme => theme.spacing(6)
            }}
          >
            {navItems?.map((item, index) => (
              <NavLinkStyled key={index} to={item.to} sx={{ fontSize: 14 }}>
                {item.label}
              </NavLinkStyled>
            ))}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export interface HeaderProps {
  navItems?: NavItem[];
  headerTo: string;
  cta?: {
    label: string;
    href: string;
  };
}

interface NavItem {
  label: string;
  to: string;
}
